// extracted by mini-css-extract-plugin
module.exports = {"text":"FormText_text__r4ZIn"};